import {Box, Grid, Stack, Typography, Checkbox, FormControlLabel, Alert} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {SymptomsBase} from '../base';
import {useState} from 'react';
import ConfirmationDialog from '../../../components/dialogbox/confirmationDialog';

/**
 * React functional component representing the Results Initial Page.
 * @component
 * @returns {JSX.Element} The rendered ResultsInitialPage component.
 */
export const ResultsInitialPage = () => {
  const [checkedAgreement, setCheckedAgreement] = useState(false);
  const [isCheckedValidated, setIsCheckedValidated] = useState(true);
  const navigate = useNavigate();

  const [confirmDialog, setConfirmDialog] = useState({
    title: '',
    subTitle: '',
    isOpen: false,
  });

  const handleCancel = () => {
    setConfirmDialog({
      title: 'Are you sure you want to cancel?',
      subTitle: 'If you cancel, you will lose your progress.',
      isOpen: true,
      onConfirm: () => {
        setConfirmDialog({
          ...confirmDialog,
          isOpen: false,
        });
        navigate('/');
      },
    });
  };

  const handleNext = () => {
    if (checkedAgreement !== false) {
      navigate('/results');
    } else {
      setIsCheckedValidated(false);
    }
  };

  const handleChangeAgreement = event => {
    setCheckedAgreement(event.target.checked);
  };

  return (
    <SymptomsBase
      pageNumber={2}
      handleBack={() => handleCancel()}
      handleNext={() => handleNext()}
      backButtonName={'Cancel'}
      nextButtonName={'See my results'}
    >
      <Stack alignItems="center" mb={{sm: 0, md: 0, lg: 14}}>
        <Typography variant="h4">Results</Typography>
        <Typography variant="subtitle2" sx={{marginTop: 3, maxWidth: '650px', width: '80%'}} textAlign="center">
          The information provided in this report is not designed or intended to constitute medical advice, or to be
          used for diagnosis.
        </Typography>
        <Typography variant="subtitle2" sx={{marginTop: 4, maxWidth: '750px', width: '80%'}} textAlign="center">
          Due to unique individual needs and medical history, please consult your own primary care provider, who will be
          able to determine the appropriateness of information for your specific situation and can assist you in making
          decisions regarding treatment and medication.
        </Typography>
        <Grid container maxWidth={1000} spacing={1} sx={{marginY: {xs: 1, md: 2}}}>
          <Grid
            item
            xs={12}
            sx={{
              textAlign: 'center',
            }}
          >
            <FormControlLabel
              labelPlacement="end"
              control={<Checkbox checked={checkedAgreement} onChange={handleChangeAgreement} />}
              label="I agree"
            />
            {!checkedAgreement && !isCheckedValidated ? (
              <Box
                fullWidth
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Alert
                  severity="error"
                  sx={{
                    mt: 2,
                    marginX: 1,
                    boxSizing: 'border-box',
                    maxWidth: '750px',
                    width: '80%',
                  }}
                >
                  You must agree to continue.
                </Alert>
              </Box>
            ) : (
              <Grid container maxWidth={1000}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      paddingTop: {xs: 0, sm: 4},
                    }}
                  ></Box>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Stack>
      {/* Confirmation dialog box when user clicks Cancel button on footer */}
      <ConfirmationDialog confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog} />
    </SymptomsBase>
  );
};
